// Map configuration - easily extendable for new libraries and levels
import { lazy } from 'react';

// Lazy so three.js / drei only download when a map is actually shown, not on every page load
const LevelMapClb1 = lazy(() => import('./level1_clb'));
const LevelMapMsl1 = lazy(() => import('./level1_msl'));
const LevelMapMsl2 = lazy(() => import('./level2_msl'));
const LevelMapMsl3 = lazy(() => import('./level3_msl'));

// Map registry: library -> level -> component
export const mapRegistry = {
  MSL: {
    1: LevelMapMsl1,
    2: LevelMapMsl2,
    3: LevelMapMsl3,
  },
  CLB: {
    1: LevelMapClb1,
    // Add more CLB levels here as needed
  },
  // Add new libraries here:
  // CCL: {
  //   1: LevelMapCcl1,
  //   2: LevelMapCcl2,
  // },
};

// Default library (can be changed based on user selection or context)
export const DEFAULT_LIBRARY = 'MSL';

// Get available levels for a library
export const getAvailableLevels = (library = DEFAULT_LIBRARY) => {
  const libraryMaps = mapRegistry[library];
  if (!libraryMaps) return [];
  return Object.keys(libraryMaps).map(Number).sort((a, b) => a - b);
};

// Get map component for library and level
export const getMapComponent = (library = DEFAULT_LIBRARY, level) => {
  const libraryMaps = mapRegistry[library];
  if (!libraryMaps) return null;
  return libraryMaps[level] || null;
};

// Check if a map exists for library and level
export const hasMap = (library = DEFAULT_LIBRARY, level) => {
  return !!getMapComponent(library, level);
};
